export default {
  network(networkCode) {
    return `https://admanager.google.com/${networkCode}`
  },
  getLineItemUrl(networkCode, lineItemId) {
    return `https://admanager.google.com/${networkCode}#delivery/line_item/detail/line_item_id=${lineItemId}`
  },
  getOrderUrl(networkCode, orderId) {
    return `https://admanager.google.com/${networkCode}#delivery/order/order_overview/order_id=${orderId}`
  },
  getCreativeUrl(networkCode, creativeCode) {
    return `https://admanager.google.com/${networkCode}#creatives/creative/detail/tab=standard&creative_id=${creativeCode}`
  },
  getInventoryUrl(networkCode, adUnitId) {
    return `https://admanager.google.com/${networkCode}#inventory/ad_unit/detail/ad_unit_id=${adUnitId}`
  },
  getYieldPartnerUrl(networkCode, adUnitId) {
    return `https://admanager.google.com/${networkCode}#inventory/ad_unit/detail/ad_unit_id=${adUnitId}`
  },
  getYieldGroupUrl(networkCode, yieldGroupId) {
    return `https://admanager.google.com/${networkCode}#delivery/yield_group/detail/yield_group_id=${yieldGroupId}`
  },
}
